import { Component } from '@angular/core';
import { environment } from '../../environment/environment';
import { Amplify,Auth } from 'aws-amplify';
import { AuthService } from '../services/auth.service';
import { AuthGuard } from '../services/guards/auth.guard';
import { Router } from '@angular/router';

// Amplify.configure({
// 	Auth: environment.cognitoConfig
// });

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.scss'],
})
export class SignoutComponent {
  constructor(
    private _authService: AuthService,
    private _authGuard: AuthGuard,
    private _router: Router
  ) {}

  // Signout using Auth directly from amplify
  // public async signOut() {
  //   try {
  //     await Auth.signOut();
  //   } catch (error) {
  //     console.log('Error signing in', error);
  //   }
  // }

  // Signout using Auth service and auth guard used from amplify
  public async signOutNew() {
    await this._authService.signOut();
  }
}
